import 'owl.carousel';

export default class carousel {

  constructor (carouselElement) {

    this.carousel = carouselElement;

    $(this.carousel).owlCarousel({
      center: true,
      loop: true,
      margin: 0,
      dots: true,
      nav: true,
      items: 1.3,
      responsive: {
        0 : {
          items: 1.3,
        },
        520 : {
          items: 2,
        },
        870 : {
          items: 1.3,
        },
      },
    });

    $(window).on('resize', () => {
      this.reflow();
    }).trigger('resize');

    $('.owl-next').data('data-cursor', 'pointer--next');
    $('.owl-prev').data('data-cursor', 'pointer--previous');
  }
  destory() {
    // destroy an owl carousel
    this.carousel.removeClass('carousel owl-carousel owl-theme owl-loaded');

    if( this.carousel.data('owl.carousel') ) {
      this.carousel.trigger('destroy.owl.carousel').removeClass('carousel owl-carousel owl-theme owl-loaded');
      this.carousel.find('.owl-stage-outer').children().unwrap();
    }
  }

  _getSmallestHeight(images) {
    let heights = images.map(function (){
        return $(this).height();
    }).get();

    return Math.min.apply(null, heights);
  }

  reflow() {
    setTimeout( () => {
      //$(this.carousel).find('.carousel__item img').css('max-height', 'unset');
      //let maxHeight = this._getSmallestHeight( $(this.carousel).find('.carousel__item img') );
      //$(this.carousel).find('.carousel__item img').css('max-height', maxHeight);
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/carousel.js